// extracted by mini-css-extract-plugin
export default {"headerLink":"style_headerLink__QmuEB","headerHolder":"style_headerHolder__fdJu0"};